function finalizeRecommendations(parent, mainProdId){
    console.log('custom recommendations loaded');

if(parent.find('.grid .grid-item[data-id="'+ mainProdId +'"]').length > 0){
  parent.find('.grid .grid-item[data-id="'+ mainProdId +'"]').remove();
  console.log('duplicate product found');
}
     
     if(parent.find('.grid .grid-item:nth-child(n+5)').length > 0){
       parent.find('.grid .grid-item:nth-child(n+5)').remove();
     }

     parent.removeClass('loading');
}
function loadSprocketRecommendations(parent, mainProdId){

var url = parent.data('sprocket-filter-url');
  
  $.ajax({
   url:url,
   type:'GET',
   success: function(data){
       //parent.find('.grid').prepend(data);
     
      $(data).insertBefore(parent.find('.grid .fallbackRecommendations').first());

     finalizeRecommendations(parent, mainProdId);
     
   },
    error: function(data){
      finalizeRecommendations(parent, mainProdId);
    }
});
}

function loadDefRecommendations(parent, mainProdId){
  
  var url = parent.data('filter-url');
  
  $.ajax({
   url:url,
   type:'GET',
   success: function(data){
      // parent.find('.grid').prepend(data);
      $(data).insertBefore(parent.find('.grid .fallbackRecommendations').first());
     loadSprocketRecommendations(parent, mainProdId);

     
   },
    error: function(data){
      finalizeRecommendations(parent, mainProdId);
    }
});
}

function loadRecommendations(){
  //console.log('loading custom recommendations');
  var parent = $('custom-product-recommendations');
  var mainProdId = $('.product-form').data('product-id');

  loadDefRecommendations(parent, mainProdId);
}

function priceToNumber(price){
  var number = Number(price.replace(/[^0-9\-]+/g,""));
  return number;
}

function numberToPrice(number){
  var currency="£",
    realPrice = (number/100).toFixed(2),
    price = currency+""+realPrice + ' GBP';
  return price;
}

  function sort_children(a, b) {
    return ($(b).data('article-date')) > ($(a).data('article-date')) ? 1 : -1;
  }
  
function allBlogsFunctions(){
  console.log('allBlogsFunctions');
  
   $(".blog-articles-grid .blog-articles-article").sort(sort_children).appendTo('.blog-articles-grid');

  $('.blog-articles').addClass('active');

}

$(document).ready(function(){

if($('[data-section-type="main-all-blogs"]').length > 0){
  allBlogsFunctions();
}
  
  if($('custom-product-recommendations').length > 0){
    loadRecommendations();
  }

  $(document).on("DOMSubtreeModified",'.bundler-cart-price-info-container-inline',function(){

   
    console.log('bundlr updated the price');

    var bundlrAmount = priceToNumber($('.bundler-cart-price-info-container-inline .conversion-bear-money:not(.bndlr-cross-out)').first().text());

    if(bundlrAmount != 0 && $('.bndlr-cross-out').length > 0){

    var vatAmount = bundlrAmount / 1.2;

    var vatPrice = numberToPrice(vatAmount);

      var oldTotalAmount = priceToNumber($('.bundler-cart-price-info-container-inline .bndlr-cross-out').first().text());

      var savedAmount = oldTotalAmount - bundlrAmount;

      var savedPrice = numberToPrice(savedAmount);

      $('.total-saved-number').html(savedPrice);

      $('.total-saved').slideDown(200);

      
      $('.vat-amount').html(vatPrice);
    
    console.log('bundlrAmount: ', bundlrAmount, 'vatPrice: ', vatPrice);

    }
    else{
      $('.total-saved').slideUp(200);
    }
  })
  var x;
$(document).on("DOMSubtreeModified",'.cart-blocks',function(){

  var parent = $(this);
  clearTimeout(x);

  x = setTimeout(function(){
    if(parent.find('.bndlr-cross-out').length == 0){
     $('.total-saved').slideUp(200);
    console.log('should remove bundle discount 1');
  }
    else{
    console.log('should show discount 1');
    }
  }, 100);
  
})

  $(document).on("DOMSubtreeModified",'.header-mini-cart-footer',function(){

   var parent = $(this);
  clearTimeout(x);

  x = setTimeout(function(){
    if(parent.find('.bndlr-cross-out').length == 0){
     $('.total-saved').slideUp(200);
    console.log('should remove bundle discount 1');
  }
    else{
    console.log('should show discount 1');
    }
  }, 100);
    
})
  
  
})

$(document).ready(function() {
  var title = $('title');
  var description = $('meta[name=description]');
  var current_page = $('meta[data-current-page]').attr('data-current-page');
  if(current_page && current_page > 1) {
    title.html(title.html() + ' - Page ' + current_page);
    description.attr('content', description.attr('content') + ' - Page ' + current_page);
  }
});

